import { useId } from 'react';
import { SUPPORTED_LOCALES, resolveLocale } from '@macksons/i18n';
import { useLocale, useT } from '../hooks';
import { useServices } from '../services';

/** Runtime language switch (Req 22.2): no reload, no re-login; the choice is persisted. */
export function LocaleSwitcher() {
  const id = useId();
  const t = useT();
  const locale = useLocale();
  const { localeStore } = useServices();
  return (
    <div className="field field--inline">
      <label htmlFor={id}>{t('common.language')}</label>
      <select id={id} value={locale} onChange={(e) => localeStore.set(resolveLocale(e.target.value))}>
        {SUPPORTED_LOCALES.map((l) => (
          // Each language name in its own script and language, for screen readers.
          <option key={l} value={l} lang={l}>
            {t(`languages.${l}`)}
          </option>
        ))}
      </select>
    </div>
  );
}
